import {Message} from 'element-ui';
let shortcuts = {};

/* 今天 */
shortcuts.today = {
    name:'today',
    text: '今天',
    async onClick(picker, _this) {
        await _this.beforePicker([new Date(),new Date()])
        picker.$emit('pick', [new Date(),new Date()], undefined, '今天');
    }
};
/* 昨天 */
shortcuts.yesterday = {
    name:'yesterday',
    text: '昨天',
    async onClick(picker, _this) {
        const date = new Date();
        date.setTime(date.getTime() - 3600 * 1000 * 24);
        await _this.beforePicker([date,date])
        picker.$emit('pick', [date,date], undefined, '昨天');
    }
};
/*前7天 - 不包含当日/今天 */
shortcuts.last7 =  {
    name:'last7',
    text: '最近7天',
    async onClick(picker, _this) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 6);
        let endDate = new Date(date.getTime());
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate,endDate], undefined, '最近7天');
    }
};
/*前14天 - 不包含当日/今天 */
shortcuts.last14 =  {
    name:'last14',
    text: '最近14天',
    async onClick(picker, _this) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 13);
        let endDate = new Date(date.getTime());
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate,endDate], undefined, '最近14天');
    }
};
/*前30天 - 不包含当日/今天 */
shortcuts.last30 =  {
    name:'last30',
    text: '最近30天',
    async onClick(picker, _this) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 29);
        let endDate = new Date(date.getTime());
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate,endDate], undefined, '最近30天');
    }
};
/*本周*/
shortcuts.thisWeek =   {
    name: 'thisWeek',
    text: '本周',
    async onClick(picker, _this) {
        // 本周：自然周，周一到周日
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let weekDay = date.getDay();
        let endDate = year+'-'+month+'-'+day;
        let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
        let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '本周');
    }
};
/*本月*/
shortcuts.thisMonth = {
    name: 'thisMonth',
    text: '本月',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let startDate = year+'-'+month+'-1';
        let endDate = year+'-'+month+'-'+day;
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '本月');
    }
};
/*本季度*/
shortcuts.thisQuarter = {
    name: 'thisQuarter',
    text: '本季度',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let startDate='';
        if([1,2,3].includes(month)){
            startDate = year+'-01-01';
        }else if([4,5,6].includes(month)){
            startDate = year+'-04-01';
        }else if([7,8,9].includes(month)){
            startDate = year+'-07-01';
        }else if([10,11,12].includes(month)){
            startDate = year+'-10-01';
        }
        let endDate = year+'-'+month+'-'+day;
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '本季度');
    }
};
/*本年*/
shortcuts.thisYear = {
    name: 'thisYear',
    text: '本年',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let startDate= year+'-01-01';
        let endDate = year+'-'+month+'-'+day;
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*上周*/
shortcuts.lastWeek =   {
    name:'lastWeek',
    text: '上周',
    async onClick(picker, _this) {
        // 上周：自然周，周一到周日
        let date = new Date(new Date().getTime()-1000*60*60*24*7);
        let weekDay = date.getDay();
        let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
        let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '上周');
    }
};
/*上月*/
shortcuts.lastMonth = {
    name:'lastMonth',
    text: '上月',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        // let firstDayOfLastMonth = new Date(year, month - 1, 1);
        // let endDayOfLastMonth = new Date(year, month, 0);
        let startDate = new Date(year, month - 1, 1)
        let endDate = new Date(year, month, 0);
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '上月');
    }
};
/*上季度*/
shortcuts.lastQuarter = {
    name:'lastQuarter',
    text: '上季度',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;

        let startDate='';
        let endDate = '';
        if([1,2,3].includes(month)){
            startDate = (year-1)+'-10-01';
            endDate = (year-1)+'-12-31';
        }else if([4,5,6].includes(month)){
            startDate = year+'-01-01';
            endDate = year+'-03-31';
        }else if([7,8,9].includes(month)){
            startDate = year+'-04-01';
            endDate = year+'-06-30';
        }else if([10,11,12].includes(month)){
            startDate = year+'-07-01';
            endDate = year+'-09-30';
        }
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '上季度');
    }
};

/*去年*/
shortcuts.lastYear = {
    name:'lastYear',
    text: '去年',
    async onClick(picker, _this) {
        let date = new Date();
        let year = date.getFullYear()-1;
        let startDate= year+'-01-01';
        let endDate = year+'-12-31';
        await _this.beforePicker([startDate, endDate])
        picker.$emit('pick', [startDate, endDate], undefined, '去年');
    }
};

export function getDateShortcuts (_this) {
    const newShortcuts = Object.keys(shortcuts).reduce((pre, item)=> {
        const shortcut = shortcuts[item];
        pre[item] = {
            ...shortcut,
             onClick(picker) {
                shortcut.onClick(picker, _this)
            }
        };
        return pre;
    }, {});
    return Object.values(newShortcuts);
}
